const {Context} = require("./frontend/contexts/context");
import _ from 'lodash'
import Swal from 'sweetalert2'
import Popper from 'popper.js'
import jQuery from 'jquery'
import 'bootstrap'
import toastr from 'toastr'
import axios from 'axios'
import Pusher from 'pusher-js'
import Echo from 'laravel-echo';

window._ = _
window.Swal = Swal.mixin({
  showConfirmButton: true,
  showCancelButton: true,
  focusConfirm: true,
  customClass: {
    popup: 'pb-0',
    actions: 'modal-footer justify-content-end w-100 m-0',
    confirmButton: 'btn btn-primary order-2',
    cancelButton: 'btn btn-outline-primary order-1',
    input: 'form-control w-auto',
  },
  buttonsStyling: false,
})

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.Popper = Popper
  window.$ = window.jQuery = jQuery
  require('select2');
  require('datatables');
} catch (e) { /* empty */ }

window.toastr = toastr

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]')?.content;
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}
window.axios.interceptors.response.use(
  response => response,
  error => {
    let errorMessage = ''

    if (error.response?.data?.errors) {
      const errors = error.response.data.errors
      Object.keys(errors).forEach(key => {
        errors[key].forEach(message => {
          errorMessage += message + '<br>'
        })
      })
    } else if (
      error.response?.data?.message
      && !error.response?.data?.brief_rename_confirmation_required
    ) {
      errorMessage = error.response.data.message
    }

    const isPdfMode = new URLSearchParams(window.location.search).has('pdf');
    if (errorMessage && !isPdfMode && !error.config?.skipErrorToast) {
      toastr.error(errorMessage)
    }

    return Promise.reject(error)
  }
)
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: true
});

window.Pusher = Pusher
window.$context = new Context;
